import { Action } from '@ngrx/store';

export const PRODUCT_CARD_MANUAL_PRICE_INIT = '[CustomProduct] Product Card Manual Price Init';

export class ProductCardManualPriceInit implements Action {
  readonly type = PRODUCT_CARD_MANUAL_PRICE_INIT;
}

export type ManualPriceActions = ProductCardManualPriceInit;
